
import React, { useRef } from 'react';
import OcrService from '../../services/ocr_service.service';
import cameraIcon from '../../assets/img/u_camera.png';
import Resizer from "react-image-file-resizer";
import CONSTANTS from '../../services/constants.service';
import FirebaseAnalytics from '../../services/analytics.service';
// Resizer.imageFileResizer(
//     file, // Is the file of the image which will resized.
//     maxWidth, // Is the maxWidth of the resized new image.
//     maxHeight, // Is the maxHeight of the resized new image.
//     compressFormat, // Is the compressFormat of the resized new image.
//     quality, // Is the quality of the resized new image.
//     rotation, // Is the degree of clockwise rotation to apply to uploaded image.
//     responseUriFunc, // Is the callBack function of the resized new image URI.
//     outputType, // Is the output type of the resized new image.
//     minWidth, // Is the minWidth of the resized new image.
//     minHeight // Is the minHeight of the resized new image.
// );
const supported_ocr_formats = ["image/jpg", "image/jpeg"];
const OcrCardScanner = props => {

    const inputRef = useRef();

    const uploadImage = async (e) => {
        e.persist();
        if (e.target.files[0]) {
            const file = e.target.files[0];
            if (!e.target.files[0] || supported_ocr_formats.indexOf(e.target.files[0]?.type) === -1) {
                e.target.value = null;
                return;
            }
            const base64 = await OcrService.convertBase64(file);
            try {
                Resizer.imageFileResizer(
                    e.target.files[0],
                    1024,
                    768,
                    "JPEG",
                    100,
                    0,
                    (uri) => {
                        props.scannedImageBase64(
                            base64,
                            uri);
                    },
                    "base64",
                );
            } catch (err) {
                // console.log(err);
            }
        }


    };


    return (
        <>
            <button
                className="scan-item-button"
                disabled={props.disabled}
                onClick={() => {
                    FirebaseAnalytics.button_clicked(CONSTANTS.OCR_FLOW_SCREEN, props.scannerDescription);
                    inputRef.current.click()
                }}
            >
                <img src={cameraIcon} className="scan-item-img" alt={"camera-icon"} />
                <div className="scan-text">
                    {props.scannerDescription}
                </div>
            </button>
            <input
                ref={inputRef}
                type="file"
                onClick={(e) => e.target.value = null}
                onChange={(e) => uploadImage(e)} style={{ display: "none" }}
                accept="image/*" />
        </>

    );
}


export default OcrCardScanner;